export const brushInstanceNames = {
  SphereBrush: "SphereBrush",
  SphereEraser: "SphereEraser",
} as const;

export const brushStrategies = {
  [brushInstanceNames.SphereBrush]: "FILL_INSIDE_SPHERE",
  [brushInstanceNames.SphereEraser]: "ERASE_INSIDE_SPHERE",
} as const;